export const EVENT_URL_PARAM = "event";

export function parseEventIdFromSearchParams(
    params: URLSearchParams
): number | null {
    const raw = params.get(EVENT_URL_PARAM)?.trim();
    if (!raw) return null;
    const id = Number(raw);
    return Number.isInteger(id) && id > 0 ? id : null;
}

export function applyEventIdToSearchParams(
    params: URLSearchParams,
    eventId: number | null
): URLSearchParams {
    const next = new URLSearchParams(params);
    if (eventId != null) next.set(EVENT_URL_PARAM, String(eventId));
    else next.delete(EVENT_URL_PARAM);
    return next;
}
